<template>
  <div class="confirm">
    <div class="header">
      <img src="@/assets/common/h5logo.png" />
      <p>
        <span>{{ userInfo.name | formatName }}</span>
      </p>
    </div>
    <div class="division"></div>
    <div class="body" v-if="!!isWxPay">
      <p>
        <img src="@/assets/common/spin.png" />
      </p>
      <p>{{ $t('请确认支付是否完成') }}</p>
      <p style="margin-top: 30px">
        <es-button type="primary" @click="checkWxPay">{{ $t('已完成支付') }}</es-button>
        <es-button variant="outline" @click="rechargeOnline">{{ $t('遇到问题重新支付') }}</es-button>
      </p>
    </div>
    <div class="body" v-else>
      <p>
        <img src="@/assets/common/success.png" />
      </p>
      <p>{{ $t('购买成功') }}</p>
      <p style="margin-top: 30px">
        <es-button variant="outline" @click="goBack">{{ $t('返回') }}</es-button>
      </p>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  data() {
    return {
      status: '',
      clock: null,
      isWxPay: this.$route.query.isWxPay || false,
    }
  },
  methods: {
    rechargeOnline() {
      // 读localStorage的参数 重新发起支付请求

      const ISANDROID = this.$route.query.client === 'APP_ANDROID'
      const returnUrl = window.localStorage.getItem('codeUrl')
      const payOrderId = window.localStorage.getItem('code')
      const href = window.localStorage.getItem('codeHref')
      if (navigator.userAgent.indexOf('MicroMessenger') > 0) {
        window.location.replace(sessionStorage.getItem('confirmUrl'))
      } else {
        this.$ajax(this.$url.weixinPay(payOrderId), ISANDROID ? {} : { returnUrl }).then(res => {
          const a = document.createElement('a')
          a.href = res.data + href
          a.id = 'weixinPay'
          document.body.appendChild(a)
          document.getElementById('weixinPay').click()
        })
      }
    },
    checkWxPay() {
      this.$ajax(this.$url.getPayOrderDetail(this.$route.query.payOrderId)).then(res => {
        if (res.data.status === 'PAY_SUCCESS') {
          this.status = 'resolve'
          this.isWxPay = false
          this.$message.success($t('支付成功'))
          window.localStorage.setItem('code', '')
          window.localStorage.setItem('codeUrl', '')
        } else if (res.data.status === 'PAY_AUDITING' || res.data.status === 'PAY_PENDING') {
          this.status = 'pending'
          this.$message.warning($t('正在获取支付结果，请稍后'))
        } else {
          this.$message.error($t('支付失败，请重新尝试支付'))
          const { status } = res.data
          if (status === 'PAY_OUT_TIME') {
            this.reason = $t('用户取消')
          }
          if (status === 'PAY_CANCEL') {
            this.reason = $t('超时取消')
          }
          if (status === 'PAY_ABEND') {
            this.reason = $t('异常终止')
          }

          this.status = 'reject'
        }
      })
    },
    goOut() {
      this.$ajax(this.$url.logout(), {}).then(res => {
        this.goBack()
      })
    },
    goBack() {
      const { orderId = '' } = this.$route.query
      const url = localStorage.getItem('returnUrl') || ''
      const isContainParams = url.indexOf('?') === -1
      window.location.href = decodeURIComponent(`${url}${isContainParams ? '?' : '&'}orderId=${orderId}`)
    },
  },
  created() {
    if (this.$route.query.payOrderId && this.isWxPay) {
      this.checkWxPay()
    }
  },
}
</script>
<style lang="less" scoped>
.header {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background: #fff;
}
.confirm {
  height: 100%;
}
.division {
  background: #f6f6f6;
  height: 10px;
}
.body {
  text-align: center;
  padding-top: 87px;
}
</style>
